import { BooleanInput, coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface ThreadListItemIconComponentState {
    isRead: boolean;
    isAssigned: boolean;
    isClosed: boolean;
}

@Component({
    selector: "dtm-ui-thread-list-item-icon[isRead][isAssigned][isClosed]",
    templateUrl: "./thread-list-item-icon.component.html",
    styleUrls: ["./thread-list-item-icon.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class ThreadListItemIconComponent {
    @Input() public set isRead(value: BooleanInput) {
        this.localStore.patchState({ isRead: coerceBooleanProperty(value) });
    }

    @Input() public set isAssigned(value: BooleanInput) {
        this.localStore.patchState({ isAssigned: coerceBooleanProperty(value) });
    }

    @Input() public set isClosed(value: BooleanInput) {
        this.localStore.patchState({ isClosed: coerceBooleanProperty(value) });
    }

    public readonly isRead$ = this.localStore.selectByKey("isRead");
    public readonly isAssigned$ = this.localStore.selectByKey("isAssigned");
    public readonly isClosed$ = this.localStore.selectByKey("isClosed");

    constructor(private readonly localStore: LocalComponentStore<ThreadListItemIconComponentState>) {
        localStore.setState({ isRead: false, isAssigned: false, isClosed: false });
    }
}
